// Character name rules, shared so the create form can warn before the server refuses.
import { nameBlocked } from './filter.js';
export const NAME_MIN = 2, NAME_MAX = 16;
const RESERVED = /^(system|server|admin|gm|mod|moderator|staff|support|dev|claude|anthropic|pixelstory)\d*$/i;

export function checkName(raw: unknown): { ok: true; name: string } | { ok: false; error: string } {
  if (typeof raw !== 'string') return { ok: false, error: 'Pick a name.' };
  const name = raw.trim();
  if (name.length < NAME_MIN || name.length > NAME_MAX) return { ok: false, error: `Names are ${NAME_MIN} to ${NAME_MAX} characters.` };
  if (!/^\p{L}[\p{L}\p{N}_'-]*$/u.test(name)) return { ok: false, error: 'Use letters and numbers (and _ \' -), starting with a letter. No spaces.' };
  if (RESERVED.test(name)) return { ok: false, error: 'That name is reserved.' };
  if (nameBlocked(name)) return { ok: false, error: "That name isn't allowed. Please pick a kinder one." };
  return { ok: true, name };
}

export const MAX_CHARACTERS = 8;
